
export enum TenantSocketEvent {
    Tenant = 'tenant',
    User = 'user',
    Room = 'room',
    Message = 'message',
    RoomPresence = 'roomPresence'
}
